__turbopack_context__.v({
  "BlogStrip": "BlogStrip-module-sass-module__YO3JUa__BlogStrip",
  "Cont": "BlogStrip-module-sass-module__YO3JUa__Cont",
  "Grid": "BlogStrip-module-sass-module__YO3JUa__Grid",
  "HideBottomBorder": "BlogStrip-module-sass-module__YO3JUa__HideBottomBorder",
  "Intro": "BlogStrip-module-sass-module__YO3JUa__Intro",
});
